"use client"

import { DateRange } from "react-day-picker"
import {
  Button,
  DatePicker,
  DropdownMenuItem,
  DropdownMenuSeparator,
} from "visuais"
import { Column } from "@tanstack/react-table"
import { EyeOff, Filter } from "lucide-react"

type Props<TData> = {
  column: Column<TData, unknown>
  accessorKey: string
  label: string
}

export function ColunaDataFiltro<TData>({
  column,
  accessorKey,
  label,
}: Props<TData>) {
  const filterValue = column.getFilterValue() as DateRange | undefined

  const handleChange = (val: DateRange | Date | undefined) => {
    if (val && typeof val === "object" && "from" in val && "to" in val) {
      column.setFilterValue(val)
    } else {
      column.setFilterValue(undefined)
    }
  }

  return (
    <>
      <DropdownMenuSeparator />
      <div className="px-2 py-2" onClick={(e) => e.stopPropagation()}>
        <div className="flex items-center gap-2 mb-2">
          <Filter className="h-3 w-3" />
          <span className="text-xs font-medium">Filtrar</span>
          {filterValue?.from && (
            <span className="text-blue-600 text-xs">✓</span>
          )}
        </div>

        <DatePicker
          mode="range"
          value={filterValue}
          onChange={handleChange}
          placeholder="Filtrar intervalo..."
          numberOfMonths={2}
        />

        {(filterValue?.from || filterValue?.to) && (
          <Button
            variant="outline"
            size="sm"
            onClick={(e) => {
              e.stopPropagation()
              column.setFilterValue(undefined)
            }}
            className="h-6 w-full text-xs mt-1"
          >
            Limpar filtro
          </Button>
        )}
      </div>

      <DropdownMenuSeparator />
      <DropdownMenuItem
        onClick={() => column.toggleVisibility(false)}
        className="flex items-center gap-2"
      >
        <EyeOff className="h-3 w-3" />
        Ocultar Coluna
      </DropdownMenuItem>
    </>
  )
}
